module.exports = __webpack_public_path__ + "715940ff03627338e3c92a48f9a6390e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-visa.svg
// module id = V/Md
// module chunks = 5